module.exports = __webpack_public_path__ + "static/media/insta.6a12c981.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/insta.png
// module id = 79
// module chunks = 0